import { OutOfStockPanel } from '@/components/sale/OutOfStockPanel';
import { useSaleSidebarData } from '@/pages/sale/context/sale-product-context';
import { memo } from 'react';

type SaleOutOfStockPanelProps = {
  onClear: () => void;
};

export const SaleOutOfStockPanel = memo(function SaleOutOfStockPanel({
  onClear,
}: SaleOutOfStockPanelProps) {
  const { outOfStocks } = useSaleSidebarData();
  return <OutOfStockPanel outOfStocks={outOfStocks} onClear={onClear} />;
});
